import HeadDetailsGama from '@/views/private/realestate/components/HeadDetails.vue'
import ModalRequest from '../modalRequest/modalRequest.vue'

export default {
  components: {HeadDetailsGama, ModalRequest},
  name: 'PaymentConditionsDetails',
  props: ['selectedSolicitacao'],
  data () {
    return { }
  },
  methods: {
    cancelarSolicitacao () {
      this.$refs['ModalRequest'].showModal()
    }
  }
}



// WEBPACK FOOTER //
// ./src/views/private/realestate/requests/components/paymentConditionsDetails/paymentConditionsDetails.js